var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBillingLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.263C10 16.88 12.015 19 14.5 19s4.5-2.12 4.5-4.737c0-2.616-2.015-4.737-4.5-4.737S10 11.647 10 14.263zm0 0c0-1.066.335-2.05.9-2.842V2.895M10 14.263c0 .782.18 1.52.499 2.17-.758.674-2.51 1.146-4.549 1.146-2.734 0-4.95-.848-4.95-1.895V2.894m9.9 0c0 1.047-2.216 1.895-4.95 1.895S1 3.941 1 2.895m9.9 0C10.9 1.848 8.684 1 5.95 1S1 1.848 1 2.895m0 8.526c0 1.046 2.216 1.895 4.95 1.895 1.97 0 3.671-.44 4.468-1.079m.482-5.08c0 1.047-2.216 1.896-4.95 1.896S1 8.204 1 7.158",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingLight);
export default __webpack_public_path__ + "static/media/billing-light.7c1cc83fd0fd1965e3c0bbb81f517958.svg";
export { ForwardRef as ReactComponent };